import { BreakpointObserver } from '@angular/cdk/layout';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';
import { Subscription } from 'rxjs';
import { AppService } from 'src/app/app.service';
import { ErrorHandlerService } from 'src/app/shared/services/error-handler.service';
import { ToastService } from 'src/app/shared/services/toast/toast.service';
import { GroupsService } from '../../groups/groups.service';
import { AppCalendarService } from '../app-calendar/app-calendar.service';
import { CalendarFormDialogComponent } from '../app-calendar/calendar-form-dialog/calendar-form-dialog.component';
import { TodosService } from './todos.service';

@Component({
  selector: 'app-todos',
  templateUrl: './todos.component.html',
  styleUrls: ['./todos.component.scss'],
  standalone: false,
})
export class TodosComponent implements OnInit, OnDestroy {
  public userData = JSON.parse(localStorage.getItem('userData') || '{}');
  public userGroups = JSON.parse(localStorage.getItem('userGroups') || '[]');

  todoForm;
  createMode;
  todoSubscription: Subscription;
  todoChangeSubscription: Subscription;
  todoConfigSubscription: Subscription;

  todoAlwaysVisible = true;
  startDate;
  endDate;
  createModeSubscription;
  groupList = [];
  selectedGroup = 'None';
  data = {
    todo: [],
    inProgress: [],
    done: [],
    delete: undefined,
  };
  allTheTodos = [];
  allTheInProgress = [];
  allTheDone = [];
  constructor(
    private dialog: MatDialog,
    private todosService: TodosService,
    private toast: ToastService,
    private calendarService: AppCalendarService,
    private appService: AppService,
    private errorHandler: ErrorHandlerService,
    private groupService: GroupsService,
    private translate: TranslateService,
    private breakpointObserver: BreakpointObserver,
    private bottomSheet: MatBottomSheet
  ) {
    this.todoConfigSubscription = this.todosService.todoDataConfigEvent$.subscribe((res) => {
      switch (res.event) {
        case 'load-todos':
          this.startDate = res.data.startDate;
          this.endDate = res.data.endDate;
          this.getTodos();
          break;
        case 'selected-group':
          this.selectedGroup = res.data;
          this.groupSelected();
          break;
        case 'add-todo':
          this.addEvent();
          break;
      }
    });
    this.createModeSubscription = this.appService.createMode$.subscribe((createMode) => (this.createMode = createMode));
    this.todoSubscription = this.todosService.todoData$.subscribe((res) => {
      this.getTodos();
    });
    this.todoChangeSubscription = this.todosService.todoChangeEvent$.subscribe((res) => {
      this.getTodos();
    });
  }

  ngOnInit() {
    this.getUserGroups();
    // this.getTodos()
  }

  ngOnDestroy() {
    this.createModeSubscription.unsubscribe();
    this.todoSubscription.unsubscribe();
    this.todoChangeSubscription.unsubscribe();
  }

  groupSelected() {
    const filterBySelectedGroup = (todo) => {
      return todo.users.findIndex((user) => user.id == this.selectedGroup) != -1;
    };
    if (this.selectedGroup == 'None') {
      this.data.todo = this.allTheTodos;
      this.data.inProgress = this.allTheInProgress;
      this.data.done = this.allTheDone;
    } else {
      this.data.todo = this.allTheTodos.filter(filterBySelectedGroup);
      this.data.inProgress = this.allTheInProgress.filter(filterBySelectedGroup);
      this.data.done = this.allTheDone.filter(filterBySelectedGroup);
    }
  }

  sortTodos(list) {
    const dateFormat = 'YYYY-MM-DD';
    this.data.todo = [];
    this.data.inProgress = [];
    this.data.done = [];
    this.allTheTodos = [];
    this.allTheInProgress = [];
    this.allTheDone = [];
    const userid = this.userData.id;
    for (const element of list) {
      let todoElement = element.statuses.find((e) => e.id == userid);
      if (!todoElement) {
        todoElement = { id: userid, status: 'todo' };
      }
      if (todoElement.status == 'todo') {
        // element.formattedStart = moment(element.start).format(dateFormat)
        this.allTheTodos.push(element);
      } else if (todoElement.status == 'inProgress') {
        // element.formattedStart = moment(element.start).format(dateFormat)
        this.allTheInProgress.push(element);
      } else if (todoElement.status == 'done') {
        // element.formattedStart = moment(element.start).format(dateFormat)
        this.allTheDone.push(element);
      }
    }
    const nameToTitle = (element) => {
      element.title = element.name;
      return element;
    };
    this.allTheTodos = this.allTheTodos.map(nameToTitle);
    this.allTheInProgress = this.allTheInProgress.map(nameToTitle);
    this.allTheDone = this.allTheDone.map(nameToTitle);
  }

  public getUserGroups() {
    this.groupService.getUserGroups().subscribe((res) => {
      const first = { _id: 'None', name: 'Aucun' };
      this.groupList = [first];
      this.groupList = this.groupList.concat(res || []);
    });
  }

  getTodos() {
    const start_date = this.startDate;
    const end_date = this.endDate;
    if (moment(start_date).isBefore(moment(end_date))) {
      this.todosService.getTodos(moment(start_date).utc().format('YYYY-MM-DD'), moment(end_date).utc().format('YYYY-MM-DD')).subscribe(
        (res) => {
          this.sortTodos(res);
          this.groupSelected();
        },
        (err) => {
          if (!this.errorHandler.handle401Error(err)) {
            this.toast.snackbar.open(this.translate.instant('Snackbar.Error'), 'Close', {
              duration: 2000,
            });
          }
        }
      );
    } else {
      this.toast.snackbar.open(this.translate.instant('Snackbar.EndBeforeStartDate'), 'OK', { duration: 4000 });
    }
  }

  public addEvent() {
    const isSmallScreen = this.breakpointObserver.isMatched('(max-width: 599px)');
    let container;

    if (isSmallScreen) {
      container = this.bottomSheet;
    } else {
      container = this.dialog;
    }

    const ref = container.open(CalendarFormDialogComponent, {
      panelClass: 'calendar-form-dialog',
      data: {
        action: 'add',
        date: new Date(),
      },
      minWidth: '500px',
      maxWidth: '60vw',
      maxHeight: '80vh',
    });

    (ref.afterClosed ? ref.afterClosed() : ref.afterDismissed()).subscribe((res) => {
      //  this.socketService.emitEvent('todo-event', { info: 'new-todo' })
      if (!res) {
        return;
      }

      const dialogAction = res.action;
      const responseEvent = res.event;
      delete responseEvent._id;
      this.calendarService.addEvent(responseEvent).subscribe((events) => {
        this.todosService.passTodoData({});
      });
      // this.todosService.passTodoData({})
    });
  }
}
